<template>
  <div id="app">
    <div v-if="showModalAddImage">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Chọn ảnh</h5>
                  <button
                    type="button"
                    @click="closeAddPhuLuc()"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center" style="max-height: 500px; overflow: scroll">
                  <div class="form-group row img-list mr-0 ml-0">
                    <ul v-viewer>
                      <li v-for="(item, index) in imageData" :key="index">
                        <a href="#popup-slider" data-toggle="modal">
                          <img :src="item" />
                          <span @click="removeImg(index)"><i class="bx bx-trash bx-sm"></i></span>
                        </a>
                      </li>
                      <li>
                        <div class="add-img">
                          <span class="bx bx-plus text-center"></span>
                          <input @input="onSelectFile" ref="fileInput" type="file" />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="modal-footer">
                  <button type="button" @click="closeAddPhuLuc()" class="btn btn-light">
                    Đóng
                  </button>
                  <button @click="submitAdd()" type="button" class="btn btn-primary">
                    Thêm ảnh
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div id="app">
      <div v-if="showModalErr">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      @click="showModalErr = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body text-center">
                    <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
                    <h2 class="f18 py-3">{{ messErr }}</h2>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-light"
                      @click="showModalErr = false"
                      data-dismiss="modal"
                    >
                      Bỏ qua
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div v-if="showLoading">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Thông báo</h5>
                </div>
                <div class="modal-body text-center">
                  <div class="box-loading d-flex justify-content-center">
                    <div class="loading f20 py-2">
                      <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
                    </div>
                  </div>
                  <h2 class="f18 py-3">{{ messErr }}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import { CommonService } from '@/services/common.service'

  export default {
    props: ['showModalAddImage', 'dataLeads', 'dataUploadImage'],

    data() {
      return {
        dataUser: JSON.parse(localStorage.getItem('userData')),
        formData: new FormData(),
        arrayFormData: [],
        arrayImgAddSuccess: [],
        imageData: [],

        showModalErr: false,
        messErr: '',
        showLoading: false,
        dataImageToAdd: [],
      }
    },

    updated() {
      this.imageData = this.dataUploadImage
      if (this.dataUploadImage.length) this.arrayImgAddSuccess = this.dataUploadImage
    },

    methods: {
      async onSelectFile() {
        if (this.imageData.length === 10) {
          alert('Chỉ tải lên tối đa 10 ảnh')
          return
        }

        const input = this.$refs.fileInput
        const files = input.files
        const fomatUpload = ['image/jpeg', 'image/png']
        const checkFomat = fomatUpload.includes(input.files[0].type)
        if (!checkFomat) {
          alert('Định dạng ảnh không đúng')
          return
        }

        var FileSize = input.files[0].size / 1024 / 1024 // in MB

        if (FileSize > 2) {
          alert('Size ảnh quá lớn')
          return
        }

        this.formData = new FormData()
        this.formData.append('files', files[0])
        this.formData.append('folderName', 'Leads')
        this.arrayFormData.push(this.formData)
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {
            this.imageData.push(e.target.result)
          }
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
      },

      async closeAddPhuLuc() {
        this.imageData = []
        this.arrayImgAddSuccess = []
        this.dataImageToAdd = []
        this.arrayFormData = []
        this.$emit('close')
      },

      async submitAdd() {
        try {
          this.$emit('close')
          this.showLoading = true
          this.messErr = 'Đang cập nhật ảnh, vui lòng chờ !'
          await this.uploadImg()
          if (this.arrayFormData.length !== 0)
            await this.$emit('submitAddImage', this.dataImageToAdd)
          this.showLoading = false
          this.closeAddPhuLuc()
        } catch (error) {
          console.log(error)
        }
      },

      async uploadImg() {
        try {
          // this.arrayImgAddSuccess = []
          for (let index = 0; index < this.arrayFormData.length; index++) {
            const element = this.arrayFormData[index]
            await CommonService.uploadImg(element).then(res => {
              if (res.code === 1000) {
                this.arrayImgAddSuccess.push(res.data[0])
              }
            })
          }
          this.arrayImgAddSuccess.map(e => {
            if (e.includes('https')) this.dataImageToAdd.push(e)
          })
        } catch (error) {
          console.log('add img reader', error)
        }
      },

      removeImg(index) {
        this.arrayImgAddSuccess.splice(index, 1)
      },
    },
  }
</script>

<style scoped>
  .modal-dialog {
    margin-top: 0;
  }
</style>
